import { Button } from 'reactstrap';
import { ExcelExportConfig } from 'utils/excel/excelTypes';
import { useExportExcel } from './useExportExcel';
// import { Cloud arrow down/ } from 'react-bootstrap-icons'

interface ExportExcelProps<T> {
  allData: T[];
  config: ExcelExportConfig<T>;
}

const ExportExcel = <T,>({
  allData,
  config,
}: ExportExcelProps<T>) => {
  const { exportToExcel } = useExportExcel<T>();

  return (
    <Button
      size="lg"
      className='download-button'
      // color="success/"
      onClick={() => exportToExcel(allData, config)}
    >
      <i className="bi bi-cloud-arrow-down"></i>
    </Button>
  );
};

export default ExportExcel;
